import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/home-update/cta-1.webp";
import { Link } from "gatsby";

function Greatproductcta() {
  return (
    <section className="great-product-cta demo p-100 text_white">
      <Container className="h-100">
        <div
          className="great-cta-products"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row className="h-100 align-items-center">
            <Col xs={12} md={10} lg={6} xl={5} xxl={5} className="">
              <h2>
                Great Products Start With <span>Bold Decisions</span> And The
                Right Tech Partner
              </h2>
              <p>
                At TekRevol, we transform your digital vision into scalable,
                high-performance solutions - on time, on brand, and beyond
                expectations.
              </p>
              <Link
                style={{ background: "#f47a14", color: "#fff" }}
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book Your Free Consultation Today!
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Greatproductcta;
